import { Link, makeStyles } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { customPalette } from '../../theme';

export interface ILineContainerProps {
    handleLinkAction: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLElement>) => void;
    linkTitle: string;
    showDivider?: boolean;
}

const useStyles = makeStyles({
    lineContainerStyle: {
        display: 'flex',
        alignItems: 'center',
        width: '530px',
        paddingLeft: '10px',
    },
    lineStyle: {
        flexGrow: 1,
        height: '1px',
        backgroundColor: customPalette.neutralTertiaryAlt,
        borderTopStyle: 'none',
        borderRightStyle: 'none',
        borderBottomStyle: 'none',
        borderLeftStyle: 'none',
        marginLeft: '14px',
    },
    linkStyle: {
        marginLeft: '16px',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '15px',
        color: customPalette.blueDark,
        marginRight: '19px',
        ':hover': {
            textDecorationLine: 'none',
            color: customPalette.themePrimary,
        },
    },
});

const LineContainerLink: React.FC<ILineContainerProps> = ({ handleLinkAction, linkTitle, showDivider }) => {
    const { t } = useTranslation();
    const styles = useStyles();

    return (
        <div className={styles.lineContainerStyle}>
            {showDivider ? <hr className={styles.lineStyle} /> : ''}
            <Link as='button' onClick={handleLinkAction} className={styles.linkStyle}>
                {t(linkTitle)}
            </Link>
        </div>
    );
};

export default LineContainerLink;
